import React, { Suspense, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const Map = React.lazy(() => import('./Map'));

const PLACEHOLDER_HEIGHT = 480;

const LazyMap = props => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);
  const isContact = props.variant === 'contact';

  useEffect(() => {
    if (!ref.current || isVisible) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px', threshold: 0 }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [isVisible]);

  const placeholder = (
    <div
      ref={ref}
      style={{
        height: isContact ? PLACEHOLDER_HEIGHT + 32 : PLACEHOLDER_HEIGHT,
        width: '100%',
        padding: isContact ? '8px 0 24px' : 0,
        boxSizing: 'border-box',
      }}
      aria-hidden="true"
    />
  );

  if (!isVisible) {
    return placeholder;
  }

  return (
    <Suspense fallback={placeholder}>
      <Map {...props} />
    </Suspense>
  );
};

LazyMap.propTypes = {
  variant: PropTypes.string,
};

export default LazyMap;
